import angular from 'angular';

import Admin from 'services/Admin';
import Auth from 'services/Auth';
import Catalog from 'services/Catalog';
import Config from 'services/Config';
import Contact from 'services/Contact';
import Plan from 'services/Plan';
import Property from 'services/Property';
import Report from 'services/Report';
import Company from 'services/Company';
import User from 'services/User';
import Subscription from 'services/Subscription';

const servicesModule = angular.module('meredicte.services', []);

servicesModule
  .service('AdminService', Admin)
  .service('AuthService', Auth)
  .service('CatalogService', Catalog)
  .service('ConfigService', Config)
  .service('ContactService', Contact)
  .service('PlanService', Plan)
  .service('PropertyService', Property)
  .service('ReportService', Report)
  .service('CompanyService', Company)
  .service('UserService', User)
  .service('SubscriptionService', Subscription);

export default servicesModule;



// WEBPACK FOOTER //
// ./src/services/services.module.js